(() => {
  const dialog = document.getElementById('cw-coming-dialog');
  if (!dialog) return;
  const heading = dialog.querySelector('h2');
  const message = dialog.querySelector('[data-coming-message]');
  document.querySelectorAll('[data-coming]').forEach(button => {
    button.addEventListener('click', () => {
      heading.textContent = button.dataset.coming;
      message.textContent = message.dataset.template.replace('__MODEL__', button.dataset.coming);
      dialog.showModal();
    });
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
})();
